import EditEndDate from './edit_end_date'
import { reduxForm } from 'redux-form'
import { endNowRemotely, updateRemotely } from 'redux/modules/campaign'
import { endDateValidators } from 'lib/end_date_validators'
import { combine } from 'lib/validators'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { endOfDay } from 'shared/helpers/datetime_helpers'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  const ended = !campaign.can_chip_in
  const endDate = campaign.end_date ? new Date(campaign.end_date) : undefined
  return {
    ended,
    endDate,
    endable: !(ended || campaign.preview),
    initialValues: {
      endDate: ended || !endDate ? undefined : endOfDay(endDate),
    },
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onSave(formValues) {
      return dispatch(
        updateRemotely(campaignId, { end_date: formValues.endDate })
      )
    },
    onEndNow() {
      return dispatch(endNowRemotely(campaignId))
    },
  }
}

export default reduxForm(
  {
    form: 'edit_end_date',
    fields: ['endDate'],
    validate: combine(...endDateValidators('endDate')),
  },
  mapStateToProps,
  mapDispatchToProps
)(EditEndDate)
